module.exports = __webpack_public_path__ + "img/cloud-fog-2.e46a47e6.svg";